import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import InfiniteScrollLoader from '../InfiniteScrollLoader';
import VideoPlayer from '../VideoPlayer';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall';
import PageHeading from '../PageHeading.jsx';
import ArticleShare from '../ArticleFeed/ArticleShare.jsx';
import ContentMeta from '../ContentMeta.jsx';
import getArticleLink from '../../util/getArticleLink';
import FeedText from '../NewsFeed/FeedText.jsx';
import csidBuilder from '../../util/csidBuilder';
import { appContext } from '../../util/decorators';

const INFINITE_SCROLL_REQUEST_LIMIT = 48;

const $loadDataSources = args => loadDataSources({
  dataSourceConfigs: _.pickBy({
    mainVideo: args.routeParams.slug ? 'articleBySlug' : null,
    allVideos: 'longformVideos',
    videoSuggestions: 'videoSuggestions',
  }),
  limit: {
    videoSuggestions: 7,
    allVideos: INFINITE_SCROLL_REQUEST_LIMIT,
  },
  ...args,
});

const mapStateToProps = state => ({
  country: state.country,
  language: state.language,
  breakpoint: state.events.breakpoint,
  allVideos: state.dataSources.allVideos,
  mainVideo: state.dataSources.mainVideo,
  sovSeed: state.ads.sovSeed,
});

const mapDispatchToProps = dispatch => ({
  loadMoreRelatedArticles: (country, routeParams, offset) => {
    return dispatch(loadDataSources({
      dataSourceConfigs: { allVideos: 'longformVideos' },
      offset: { allVideos: offset },
      limit: { allVideos: INFINITE_SCROLL_REQUEST_LIMIT },
      country,
      routeParams,
    }));
  },
});

@loadAction($loadDataSources)
@connect(mapStateToProps, mapDispatchToProps)
@appContext
export default class Longform extends React.PureComponent {

  constructor(props) {
    super(props);
    this.currentArticleOffset = _.size(props.allVideos) || INFINITE_SCROLL_REQUEST_LIMIT;
    this.state = {};
  }

  selectVideo(selectedVideo) {
    this.setState({selectedVideo});
    window.history.replaceState('', '', getArticleLink(selectedVideo, {href: true, noHost: true}));
    window.scrollTo(0, 0);
  }

  loadMoreArticles() {
    const { country, routeParams, loadMoreRelatedArticles } = this.props;

    const promise = loadMoreRelatedArticles(country, routeParams, this.currentArticleOffset);

    this.currentArticleOffset += INFINITE_SCROLL_REQUEST_LIMIT;

    return promise;
  }

  render() {
    const { t } = this.context.app;
    const { mainVideo, allVideos, country, breakpoint, sovSeed } = this.props;
    const { selectedVideo } = this.state;

    const article = selectedVideo || _.first(mainVideo) || _.first(allVideos) || {};
    const video = _.first(article.videos);

    if (!video) return null;

    let csid = '';
    if (breakpoint) csid = csidBuilder({ csidParam: 'premium', country, breakpoint, mediaName: article.tags.programType.slug });
//autoplay replaced by autoplay={true}
    const topView = (
      <div className="longform-page">
        <PageHeading firstPart={t('Premium.heading')} secondPart={_.get(article, 'tags.programType.name')} />

        <div className="thumbnail thumbnail-video">
          <VideoPlayer
                  key={article.id}
                  video={video.data}
                  article={article}
                  autoplay
                  //autoplay={true}
                  csid={csid}
                  sovSeed={sovSeed}
                  firstArticle
                  initPlayer
                  videoElementId={`video-${article.id}`}/>
        </div>

        <ContentMeta data={article} />

        <h2><FeedText contentContainer={article}/></h2>

       <ArticleShare contentContainer={article} />

        <div className="longform-item-container">
        {
          _.map(allVideos, container =>
            <div key={container.id} className="longform-item">
              <FeedContainerSmall onClick={this.selectVideo.bind(this)}
                                  isCurrentlyPlayed={article.id === container.id}
                                  contentContainer={container} />
            </div>
          )
        }
        </div>

        <InfiniteScrollLoader lastRequestedOffset={this.currentArticleOffset}
                              loadedOffset={_.size(allVideos)}
                              loadMore={() => this.loadMoreArticles()} />
       </div>
    );

    return (
      <PageWithSidebars hideMainContent topView={topView}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Longform/Longform.jsx